/**
 * Provenance and seal finishing for the older workflow documents.
 *
 * The newer builds do this inside their own builders. The older workflows
 * assemble their HTML in many places, so they all pass the finished page
 * through here: the page is titled with the Association name, and the seal is
 * placed only when the Association keeps one and the steward applied it.
 */

import { withEntityTitle } from './docProvenance';
import { sealBlockHtml, SEAL_STYLE_CSS, type SealContext } from './sealModel';

export interface LegacyFinishOptions extends SealContext {
  /** The Association name. Used for the page title and the PDF metadata. */
  entityName?: string | null;
}

/**
 * Titles the page with the Association name and, when a seal is applied,
 * places the seal mark at the end of the page with its caption.
 * When no seal is applied, nothing is added at all: no circle, no caption,
 * no mention.
 */
export function finishLegacyHtml(html: string, opts: LegacyFinishOptions): string {
  let out = withEntityTitle(html, opts.entityName);

  const seal = sealBlockHtml(opts);
  if (!seal) return out;

  const styled = `<style>${SEAL_STYLE_CSS}</style>`;
  if (/<\/head>/i.test(out)) {
    out = out.replace(/<\/head>/i, `${styled}</head>`);
  } else {
    out = `${styled}${out}`;
  }

  if (/<\/body>/i.test(out)) {
    return out.replace(/<\/body>/i, `${seal}</body>`);
  }
  return `${out}${seal}`;
}
